import { render, staticRenderFns } from "./index.vue?vue&type=template&id=29ad25f0&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=29ad25f0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ad25f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29ad25f0')) {
      api.createRecord('29ad25f0', component.options)
    } else {
      api.reload('29ad25f0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=29ad25f0&scoped=true", function () {
      api.rerender('29ad25f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/purchase/inventory-prediction/index.vue"
export default component.exports